import React from 'react';
import { Stack, Typography } from '@mui/material';
import parse from 'html-react-parser';

import type { TextContentBlock } from '../../../_types/dtb';

interface ContentBlockPreviewProps {
  block: TextContentBlock;
}

const ContentBlockPreview: React.FC<ContentBlockPreviewProps> = ({ block }) => {
  return (
    <Stack spacing={3}>
      {block.title && <Typography variant='subtitleSm'>{block.title}</Typography>}
      <Typography
        variant='bodySm'
        component='div'
      >
        {parse(block.content)}
      </Typography>
    </Stack>
  );
};

export default ContentBlockPreview;
